import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from '@/components/Link';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { SoMe, SoMeProps } from './SoMe';

export interface StandaloneSoMeProps extends StandaloneComponentProps {
  href?: DynamicStandaloneLinkProps['href'];
  name?: SoMeProps['name'];
  content?: React.ReactNode;
  options?: Omit<SoMeProps, 'name'> & {
    $link?: DynamicStandaloneLinkProps['options'];
  };
}

export const StandaloneSoMe: StandaloneComponent<StandaloneSoMeProps> = ({
  href,
  name,
  options,
  content,
  ...props
}) => {
  const { $link: linkProps, ...baseProps } = options || {};

  return (
    <DynamicStandaloneLink
      href={href}
      target="_blank"
      options={linkProps}
      content={
        <SoMe name={name} {...baseProps} {...props}>
          {content}
        </SoMe>
      }
    />
  );
};

export default StandaloneSoMe;
